module.exports = __webpack_public_path__ + "static/media/CV.5063cc8d.pdf";